import { render } from "./SettingsScreen.vue?vue&type=template&id=e0750d6e"
import script from "./SettingsScreen.vue?vue&type=script&lang=js"
export * from "./SettingsScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__